import React from 'react';
import cn from 'clsx';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';
import TirePressureWarningSolidIcon from '../../shared/icons/tire-pressure-warning-solid-icon';

import { useMessage } from '../../shared/hooks/hooks';

import { TPMS_ACCESSORY_TOOLTIP_TEXT_MSG } from '../../shared/constants/messages';

import styles from './tpms-accessory-message.scss';

interface TpmsAccessoryMessageProps {
  className?: string;
}

function TpmsAccessoryMessage(props: TpmsAccessoryMessageProps) {
  const { className } = props;
  const messages = useMessage([TPMS_ACCESSORY_TOOLTIP_TEXT_MSG]);

  return (
    <Typography
      className={cn(styles['container'], `tpms-accessory-message ${className}`)}
    >
      <TirePressureWarningSolidIcon />
      <span>Tire Pressure Monitoring System (TPMS)</span>
      <Tooltip content={messages?.TPMS_ACCESSORY_TOOLTIP_TEXT_MSG} />
    </Typography>
  );
}

export default TpmsAccessoryMessage;
